import { render } from "./ManualDiscount.vue?vue&type=template&id=7a65e971&scoped=true"
import script from "./ManualDiscount.vue?vue&type=script&lang=js"
export * from "./ManualDiscount.vue?vue&type=script&lang=js"

import "./ManualDiscount.vue?vue&type=style&index=0&id=7a65e971&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65e971"]])

export default __exports__